import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const BackToCourseTop = () => {
  const navigate = useNavigate();
  useEffect(() => {
    navigate("/courses");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <></>;
};
